module.exports = __webpack_public_path__ + "static/media/go-pro.ed00b1ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/overlay-icons/go-pro.svg
// module id = 882
// module chunks = 0